var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("./jcb-logo.png"),"width":_vm.size+'px'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }